import {Inject, Injectable} from '@angular/core';
import {Store} from "@ngrx/store";
import {Service} from "../../models/service.model";
import {ServicesActions, ServicesAPiActions, ServicesChannelActions} from "../state/services.action";
import {servicesFeature} from "../state/services.state";
import {Observable, take} from "rxjs";
import {EntitiesFacade} from "../../../commons/angular/classes/entities-facade";

@Injectable()
export class ServicesFacadeService implements EntitiesFacade<Service> {

  constructor(@Inject(Store) private store: Store<Service>) {
  }

  clearStore(): void {
    this.store.dispatch(ServicesActions.clearStore());
  }

  createOne(entity: Service): void {
  }

  deleteOne(id: string, shouldMask?: boolean): void {
  }

  fetchNext(params?: Object, isSubscribeToChannel?: boolean): void {
    this.store.select(servicesFeature.selectCursor()).pipe(take(1)).subscribe((cursor) => {
      if (!!cursor) {
        this.store.dispatch(ServicesAPiActions.getInfiniteScrollServices({params: params, isSubscribeToChannel: isSubscribeToChannel}));
      }
    })
  }

  getMany(params?: Object, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(ServicesAPiActions.getServices({params: params, isSubscribeToChannel: isSubscribeToChannel}));
  }

  getMapServicesInBatches(params?: Object, isSubscribeToChannel?: boolean, batchSize?: number, maxItems?: number, intervalMs?: number): void {
    this.store.dispatch(ServicesAPiActions.getMapServicesInBatches({
      params,
      isSubscribeToChannel,
      batchSize,
      maxItems,
      intervalMs
    }));
  }

  getInfiniteScrollEntities(params?: Object, isSubscribeToChannels?: boolean): void {
    this.store.dispatch(ServicesAPiActions.getInfiniteScrollServices({params: params, isSubscribeToChannel: isSubscribeToChannels}));
  }

  getOne(serviceId: string, isSubscribeToChannel?: boolean): void {
    this.store.dispatch(ServicesAPiActions.getService({serviceId: serviceId, isSubscribeToChannel: isSubscribeToChannel}));
  }

  removeAll(): void {
    this.store.dispatch(ServicesActions.removeAll());
  }

  removeByIds(ids: string[]): void {
    this.store.dispatch(ServicesActions.removeServices({ids: ids}));
  }

  selectOne(id: string) {
    return this.store.select(servicesFeature.selectService(id));
  }

  selectByIds(ids: string[]): Observable<Service[]> {
    return this.store.select(servicesFeature.selectServicesById(ids));
  }

  selectAll(): Observable<Service[]> {
    return this.store.select(servicesFeature.selectServices());
  }

  selectInfiniteScrollEntities(): Observable<Service[]> {
    return this.store.select(servicesFeature.selectInfiniteScrollServices());
  }

  setMany(services: Service[], isAppendFirst?: boolean): void {
    this.store.dispatch(ServicesActions.setServices({services: services, isAppendFirst: isAppendFirst}))
  }

  setInfiniteScrollServices(services: Service[], isAppendFirst?: boolean) {
    this.store.dispatch(ServicesActions.setInfiniteScrollServiceIds({
      serviceIds: services.map(s => s.id),
      isAppendFirst: isAppendFirst
    }));
    this.store.dispatch(ServicesActions.setServices({services: services, isAppendFirst: isAppendFirst}))
  }

  setOne(entity: Service): void {
  }

  subscribeToChannels(): void {
    this.store.dispatch(ServicesChannelActions.subscribe());
  }

  unsubscribeFromChannels(): void {
    this.store.dispatch(ServicesChannelActions.unsubscribe());
  }

  editOne(id: string, entity: Service): void {
  }

  selectIsLoading(): Observable<boolean> {
    return this.store.select(servicesFeature.selectIsLoading());
  }

  selectInitialized(): Observable<boolean> {
    return this.store.select(servicesFeature.selectInitialized());
  }

  updateOne(service: Service): void {
    this.store.dispatch(ServicesActions.updateService({service: service}));
  }

  updateMany(services: Service[]): void {
    this.store.dispatch(ServicesActions.updateServices({services: services}));
  }

}
